import React from 'react';
import { percentage } from 'Helpers/NumberInputFormats';
import NumberInput from '../NumberInput';

import './index.css';

const Percentage = props => <NumberInput {...percentage} {...props} />;

export default Percentage;
